import { Inject } from 'inversify-props'
import { Page, Estoque, FiltroDaTelaDeEstoques, EstoqueProjection } from '@/models'
import { EstoqueServiceAdapter } from '.'
import { AxiosRequestConfig } from 'axios'

export class FindEstoqueUseCase {

	@Inject('EstoqueServiceAdapter')
	private estoqueService!: EstoqueServiceAdapter

	findEstoques = async (filtros?: FiltroDaTelaDeEstoques, config?: AxiosRequestConfig): Promise<Page<Estoque>> =>
		await this.estoqueService.buscarEstoques(filtros, config)

	findOtimizado = async (params?: any, config?: AxiosRequestConfig): Promise<Page<EstoqueProjection>> =>
		await this.estoqueService.findOtimizado(params, config)

	getEstoque = async (idDeposito: string, idEstoque: string): Promise<Estoque> =>
		await this.estoqueService.get(idDeposito, idEstoque)

	getEstoqueDoItemDaVendaNaLoja = async (idProduto: string, quantidadeDeItens: string, idLoja: string): Promise<Estoque> =>
		await this.estoqueService.getEstoqueDoItemDaVendaNaLoja(idProduto, quantidadeDeItens, idLoja)
}